import gql from 'graphql-tag';

export const printProductSizeServiceDetails = gql`
  fragment printProductSizeServiceDetails on PrintProductSizeService {
    id
    print_service {
      id
      name
      description
    }
    price {
      value
      currency
    }
  }
`;

export const printProductSizeRoesGraphicNodeDetails = gql`
  fragment printProductSizeRoesGraphicNodeDetails on PrintProductSizeRoesGraphicNode {
    id
    roes_graphic_node {
      node_id
      image_url
      ui_label
    }
  }
`;

export const printProductSizeBaseDetails = gql`
  fragment printProductSizeBaseDetails on PrintProductSize {
    id
    print_size {
      id
      name
    }
    orientations
    mounts {
      total
    }
    total_price {
      value
      currency
    }
    services {
      total
      records {
        ...printProductSizeServiceDetails
      }
    }
    roes_info {
      image_nodes {
        id
        ui_description
        ui_label
        bounds
        is_required
      }
      text_nodes {
        id
        ui_description
        ui_label
        bounds
        is_required
        default_text
      }
      graphic_nodes {
        total
        records {
          ...printProductSizeRoesGraphicNodeDetails
        }
      }
    }
    preview_asset_image {
      id
      url
    }
  }
  ${printProductSizeServiceDetails}
  ${printProductSizeRoesGraphicNodeDetails}
`;

export const printProductBaseDetails = gql`
  fragment printProductBaseDetails on PrintProduct {
    id
    name
    card {
      id
    }
    preview_asset_image {
      id
      url
      width
      height
    }
    sizes(slice: { limit: 999 }) {
      total
      records {
        ...printProductSizeBaseDetails
      }
    }
  }
  ${printProductSizeBaseDetails}
`;
